// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox[data-v-b11dd83a]{width:20px;height:20px;border:1px solid #373534;cursor:pointer;display:inline-block}.checkbox.active[data-v-b11dd83a]{border:1px solid #9a7c5d}.checkbox.active[data-v-b11dd83a]::before{opacity:1}.checkbox[data-v-b11dd83a]::before{content:\"\";width:10px;height:10px;position:absolute;background-color:#9a7c5d;margin-top:4px;margin-left:4px;opacity:0}", ""]);
// Exports
module.exports = exports;
